// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Recalculate amortization schedule'"></sub-header>
  <div class="content">
    <form name="\$ctrl.form">
      <form-section>
        <loan-preview loan="\$ctrl.loan"
                      loan-type="\$ctrl.loan.loanType"
                      waive-request="\$ctrl.waiveRequest">
        </loan-preview>
        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.save()" ng-disabled="\$ctrl.isAlreadyAdjusted()">Save</button>
        </div>
      </form-section>
    </form>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/recalculate-amortization-schedule/recalculate-amortization-schedule.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;